import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface Country {
  flag: string;
  name: string;
  dialCode: string;
  example: string;
}

@Injectable({
  providedIn: 'root'
})
export class PhoneCodesService {

   private countriesUrl = 'assets/db/phone-codes/phone-codes.json';

  constructor(private http: HttpClient) {}

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(this.countriesUrl);
  }
}
